
<div class="row" style="height: 80vh;overflow-y: scroll;">
    <div class="col-12 col-sm-12 col-md-12">
        <button type="button" class="btn btn-outline-primary btn-icon round mr-1 mb-1 float-end" (click)="reload()">
            <i class="feather icon-feather-refresh-ccw"></i>
        </button>
    </div>
    <div class="col-12 col-sm-12 col-md-12">
        <div class="col-12 text-center">
            <span *ngIf="dataLoadingFlag" class="spinner-border spinner-border-sm mr-1"></span>
        </div>
        
        <div class="col-12">
            <input type="text" name="search" class="form-control" [(ngModel)]="searchTerm" placeholder="Search...." (change)="renderData()">
            <div class="list-group list-group-flush">
                <a *ngFor="let row of rows; let i = index"  (click)="selectAddress(row)" class="list-group-item" style="cursor:pointer">
                    <b>{{row.firstname}} {{row.lastname}}</b>
                    <br>
                    {{row.company_name}}
                    <br>
                    {{row.email}} / {{row.contact_no}}
                    <br>
                    {{row.address_1}} <br>
                    {{row.address_2}}
                    {{row.suburb +' '+ row.state +' '+ row.postcode+' '+ row?.country?.country_name}}
                </a>
              
              </div>
          
            <!-- paginator -->
            <nav *ngIf="numbers.length > 1">
                <ul class="pagination justify-content-center">
                <li id="prev" class="page-item" [ngClass]="{ 'disabled': this.filters.page === 1 }">
                    <button class="page-link" href="#" (click)="prev()">Previous</button>
                </li>
                <ng-container *ngIf="response">
                    <li class="page-item" *ngFor="let number of numbers" [ngClass]="{ 'active': this.filters.page === number }">
                    <button class="page-link" href="#" (click)="to(number)">{{number}}</button>
                    </li>
                </ng-container>
                <li id="next" class="page-item" [ngClass]="{ 'disabled': this.filters.page === numbers.length }">
                    <button class="page-link" (click)="next()">Next</button>
                </li>
                </ul>
            </nav>
        </div>
    </div>
</div>
